import { Component, Input, type OnInit } from '@angular/core';

@Component({
  selector: 'app-basic-card',
  templateUrl: './basic-card.component.html',
  styleUrl: './basic-card.component.scss'
})
export class BasicCardComponent implements OnInit {

  @Input() css = '';

  ngOnInit(): void { }

}
